import { Component, OnInit } from '@angular/core';
// import { HeaderService } from './services/header.service';
// import { HeaderItem } from './components/header/header-item';
// import { FooterService } from './services/footer.service';
// import { FooterItem } from './components/footer/footer-item';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService, AuthService, SessionService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  // headers: HeaderItem[];
  // footers: FooterItem[];
  
  constructor (
    private router: Router,
    private authService: AuthService,
    private apiService: ApiService,
    private sessionService: SessionService,
    private adminService: SessionService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    // parse sso token if available 
    let token = this.sessionService.getQueryVariable("ot");
    let return_url = this.sessionService.getQueryVariable("ReturnUrl", false);
    return_url = return_url.replace('%26', '&');
    console.log("ReturnUrl", return_url);
    // try authenticate with sso token
    if (token) {
      this.processSSO(token, return_url);
    } else {
      this.checkAuthentication();
    }
  }

  checkAuthentication() {
    this.authService.populate().subscribe(
      user => {
         if (user == null) {
          this.authService.logoff();
         }
      },
      err => { 
        this.authService.logoff();
      }
    )    
  }

  processSSO(token:string, return_url:string) {
    this.authService.ssoLogin(token).subscribe(
      user => {
        if (user.session_token) {
          this.sessionService.saveOneTimeToken(token);
          // user with valid session token 
          let home_page = this.authService.getAuth().home_page;
          if (return_url && return_url.length > 0) home_page = return_url;
          if (home_page && home_page.length > 0) {
            this.router.navigateByUrl(home_page);
          } else {
            let test_page = 'oomph/dashboard';
            this.router.navigateByUrl(test_page);
          }
        } else {
          this.authService.logoff();
        }
      }, 
      err => {
        console.log("sso failed" + err);
        this.authService.logoff();
      }
    )
  }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/app.component.ts